<template>
  <div>
    <notifications group="b2b"/>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      notifications: state => state.notifications
    })
  },
  watch: {
    notifications() {
      let basket = this.notifications.find(a => {
        if (!(a === undefined)) {
          return a.key == "newBasketProduct";
        }
      });
      let offer = this.notifications.find(a => {
        if (!(a === undefined)) {
          return a.key == "newOfferProduct";
        }
      });
      let contact = this.notifications.find(a => {
        if (!(a === undefined)) {
          return a.key == "contactForm";
        }
      });
      if (!(basket === undefined)) {
        this.$notify({
          group: "b2b",
          title: "Produkt dodany do koszyka!",
          type: "success"
        });
        this.$store.dispatch("removeNotification", basket.key);
      } else if (!(offer === undefined)) {
        this.$notify({
          group: "b2b",
          title: "Produkt dodany do oferty!",
          type: "success"
        });
        this.$store.dispatch("removeNotification", offer.key);
      } else if (!(contact === undefined)) {
        this.$notify({
          group: "b2b",
          title: "Wiadomość została wysłana!",
          type: "success"
        });
        this.$store.dispatch("removeNotification", contact.key);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/template/Notifications.vue